function createHamburgerMenu () {

  var ww = window.innerWidth;
  var currentWidth = window.innerWidth;
  var breakpoint = 960;

  var $toggle = $('#toggle');
  var $gnavi = $('#gnavi');
  var $html = $('html');
  var $backdrop = $('#backdrop');

  $(document).ready(function() {
    checkGnavWidth();
  });

  // リサイズ時の処理
  window.addEventListener("resize", function () {
    if ( currentWidth == window.innerWidth ) {
      return false;
    }
    checkGnavWidth();
    currentWidth = window.innerWidth;
  });

  // ハンバーガーボタンクリック
  $toggle.on('click', function () {
    toggleMenu();
  });

  // バックドロップクリック
  $backdrop.on('click', function () {
    if ($toggle.hasClass('is-toggleActive')) {
      toggleMenu();
    }
  });

  // リンクをクリックしたらメニューを閉じる
  // ナビゲーション内の a タグをクリックしたとき
  // ただし、ドロップダウンの親（開閉トリガー）は除外する
  $gnavi.find('a').not("[data-js='dropDown'] > a").on('click', function(e) {
    // スマホメニューが開いている場合のみ実行
    if ($toggle.hasClass('is-toggleActive')) {
      toggleMenu();
    }
  });

  function toggleMenu() {
    $toggle.toggleClass('is-toggleActive');
    $html.toggleClass('open');

    if ( $toggle.hasClass('is-toggleActive') ) {
      $gnavi.addClass('is-navOpen');
      $backdrop.fadeIn(300);

    } else {
      $gnavi.removeClass('is-navOpen');
      $backdrop.fadeOut(300);
    }

    $gnavi.stop().slideToggle(500, function () {
      if( $(this).hasClass('is-navOpen') ) {
        $(this).css('display','block');
      } else {
        $(this).css('display','none');
      }
    });
  }

  function checkGnavWidth () {
    ww = window.innerWidth;

    $("[data-js='dropDown'] > a").off('click');

    if( ww > breakpoint ) {
      // PC
      $gnavi.css('display','block');
      $backdrop.hide();
      $toggle.removeClass('is-toggleActive');
      $html.removeClass('open');
      $gnavi.removeClass('is-navOpen');
    } else {
      // SP
      if( !$toggle.hasClass('is-toggleActive') ) {
        $gnavi.css('display','none');
      }
    }
    globalNavInit();
  }

  function globalNavInit () {
    if( ww >= breakpoint ) {
      // PC挙動
      $("[data-js='dropDown'] > a").on('click', function(e){
        // リンク遷移をキャンセル
        e.preventDefault();

        // PC用ドロップダウン開閉処理
        var $parent = $(this).parent("[data-js='dropDown']");
        if ($parent.hasClass('isDropdownOpen')) {
          $parent.removeClass('isDropdownOpen');
        } else {
          $("[data-js='dropDown']").removeClass('isDropdownOpen');
          $parent.addClass('isDropdownOpen');
        }
      });
      $(".l-dropDown").css('display', '');

    } else {
      // SP挙動
      $("[data-js='dropDown'] > a").on('click', function(e){
        e.preventDefault();

        var $parent = $(this).parent("[data-js='dropDown']");
        var $dropDown = $parent.find('.l-dropDown');

        $parent.toggleClass('isDropdownOpen');
        $dropDown.stop().slideToggle(300);
      });
    }
  }
}